function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      timeout = null;
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

window.addEventListener('DOMContentLoaded', () => {
  const searchButton404 = document.querySelector("[data-search-big-button]");
  /* Here we load all the algolia QOL features */
  const toggleSearchButton = document.querySelector(
    "[data-predictive-search-open-drawer]"
  );
  const searchWrapper = document.querySelector("[data-search-container]");
  const searchHitsContainer = document.querySelector('[data-search-hits-container]');
  const searchOverlay = document.querySelector("[data-search-overlay]");
  const closeHamburger = document.querySelector("[data-search-close-button]");
  const searchForm = document.querySelector("[data-search-form]");
  const mobileCategoryButtons = document.querySelectorAll('[data-search-mobile-categories-button]');
  const mobileProductCategoryButton = document.querySelector('[data-search-mobile-categories-button-product]');
  const mobileBlogCategoryButton = document.querySelector('[data-search-mobile-categories-button-blog]');
  const productHitsContainer = document.querySelector('[data-hits]');
  const blogHitsContainer = document.querySelector('[data-hits-blog]');
  const searchInput = document.querySelector("[data-search-input]");
  let prevQuery = "";

  const attachSearchResultsClickTracking = () => {
    const allProductResults = document.querySelectorAll('[data-search-result]');
    const allBlogResultsFromSearch = document.querySelectorAll('[data-blog-link-search]');

    allProductResults.forEach(product => {
      const { productId }  = product.dataset
      const productTitle = product.querySelector('[data-product-title]').innerHTML;

      product.addEventListener('click', e => {
        window.dataLayer.push({
          "event": "ap_product_click",
          "path": window.location.pathname,
          "type": "search",
          "products": [{
            "name": productTitle.replace("'", ''),
            "id": productId.toString()
          }],
          "query": searchInput.value
        });
      });
    });

    allBlogResultsFromSearch.forEach(blogLink => {
      blogLink.addEventListener('click', e => {
        window.dataLayer.push({
          "event": "ap_blog_click",
          "path": window.location.pathname,
          "type": blogLink.dataset.blogClickType,
          "title": blogLink.dataset.blogTitle
        });
      });
    });
  };

  const handleSearchInputKeyup = debounce(() => {
    if(searchInput.value === "") {
      searchHitsContainer.classList.add('hide');
      prevQuery = searchInput.value;

      return;
    }

    if (prevQuery !== searchInput.value) {
      const fetchQuery = `/search/suggest?q=${searchInput.value}&resources[type]=product,article&resources[options][fields]=author,body,title,product_type,variants.title,variants.sku,tag&section_id=search-results`;

      // window.dataLayer.push({
      //   "event": "ap_search",
      //   "query": searchInput.value,
      //   "path": window.location.pathname
      // });

      fetch(fetchQuery)
        .then((response) => {
          requestResponse = response;
          return response.text();
        })
        .then((text) => {
          if (!requestResponse.ok) {
            throw new Error(`${requestResponse.status}: ${text}`);
          }
          const newMarkup = new DOMParser().parseFromString(text, 'text/html');
          productHitsContainer.innerHTML = newMarkup.querySelector('[data-hits]').innerHTML;
          blogHitsContainer.innerHTML = newMarkup.querySelector('[data-hits-blog]').innerHTML;
          searchHitsContainer.classList = newMarkup.querySelector('[data-search-hits-container]').classList;
          attachSearchResultsClickTracking()
          searchHitsContainer.style.height = `${window.innerHeight - searchHitsContainer.getBoundingClientRect().top}px`
        })
        .catch((error) => {
          console.error(error);
        });

      prevQuery = searchInput.value;
    }
  }, 500);

  const handleSearchEscKey = e => {
    if (e.key !== "Escape") return;

    if (!prevQuery) {
      toggleSearch();
    } else if (searchInput.value) {
      searchInput.value = '';
      handleSearchInputKeyup();
      searchInput.focus();
    }
  };

  const toggleSearch = () => {
    const open = !document.body.classList.contains('search-active');
    const headerContainer = document.querySelector('header');

    document.body.classList[open ? 'add' : 'remove']('search-active');
    (open ? lockBody : unlockBody)(searchHitsContainer);
    document[open ? 'addEventListener' : 'removeEventListener']('keyup', handleSearchEscKey, true);

    if (open) {
      // Adjust search container top heights to correspond to header + announcement bar positions
      const headerBottom = document.querySelector("[data-site-header-container]").getBoundingClientRect().bottom;
      const headerAdjustment = window.innerWidth < 1024 ? `${headerBottom - 10}px` : `${headerBottom - 30}px`;
      headerContainer.classList.add('dark:bg-black');
      searchWrapper.style.top = headerAdjustment;
      searchOverlay.style.top = headerAdjustment;
      // ensure search__hits-container height is accurate even if header has announcement bar or not (which changes header height)
      searchHitsContainer.style.height = `${window.innerHeight - searchHitsContainer.getBoundingClientRect().top}px`;
      searchInput.focus();
    } else {
      headerContainer.classList.remove('dark:bg-black');
    }
  }

  // Stop submit on search form as that redirects to /search page
  searchForm.addEventListener("submit", (e) => {
    e.preventDefault();
  });

  searchInput.addEventListener('keyup', handleSearchInputKeyup);

  toggleSearchButton?.addEventListener("click", toggleSearch);
  closeHamburger?.addEventListener("click", toggleSearch);
  searchButton404?.addEventListener("click", toggleSearch);

  mobileCategoryButtons.forEach(button => {
    button.addEventListener('click', e => {
      e.preventDefault();
      mobileBlogCategoryButton.classList.toggle('active');
      mobileProductCategoryButton.classList.toggle('active');
      productHitsContainer.classList.toggle('active');
      blogHitsContainer.classList.toggle('active');
    });
  });
});